import React from "react";
import "./Showroom.css";

import Category from "components/Category";
import { Row, Col } from "react-bootstrap";

export default props => {
  let { categories, currentProductId, showroom } = props.showroom;
  let { handleProductSelect } = props;
  let currentProduct;
  //let currentCategory;
  if (!currentProductId) return null;
  for (let i = 0; i < categories.length; i++) {
    let category = categories[i];
    let product = category.Products.find(
      product => product.id === currentProductId
    );
    if (product) {
      currentProduct = product;
      //currentCategory = category;
      break;
    }
  }

  return (
    <Row id="contents" style={{ margin: 0 }}>
      <div className="contents-inner">
        <Row id="contents-title">
          <Col md={12} sm={12} sx={6} className="reset-col">
            <ul className="topicpath">
              <li>
                <a href="http://www.lixil.co.jp/">ホーム</a>
              </li>
              <li>
                <a href="http://www.lixil.co.jp/showroom">ショールーム</a>
              </li>
              <li>
                <a href={"http://www.lixil.co.jp/showroom/" + showroom.Area.directory}>{showroom.Area.name}</a>
              </li>
              <li>
                <a href={"http://www.lixil.co.jp/showroom/" + showroom.Area.directory + "/" + showroom.directory}>{showroom.name}</a>
              </li>
              <li>展示品写真</li>
            </ul>
            <h1>{showroom.name}：展示品写真</h1>
            <p id="returnshowroom" className="btn-back">
              <a href={"http://www.lixil.co.jp/showroom/" + showroom.Area.directory + "/" + showroom.directory}>ショールーム詳細ページに戻る</a>
            </p>
            <h2>
              キッチン・浴室など各空間の写真をクリックすると、ショールームに展示している商品を360度写真でご覧いただけます。
            </h2>
            <p className="note">
              ※写真をクリックしながらスクロールすると、お好きな角度で商品をご覧頂けます。
            </p>
          </Col>
        </Row>
        <Row className="content-products">
          <Col
            className="content-products-360 reset-col"
            md={12}
            sm={12}
            sx={6}
          >
            <div className="aspect-ratio">
              <iframe
                allowFullScreen="true"
                className="iframe-360"
                src={currentProduct.ShowroomProducts[0].panoImageUrl}
                frameBorder="0"
                scrolling="no"
                title="LIXIL"
              />
            </div>
          </Col>
          <Row>
          <a href="http://kantan-navi.lixil.co.jp/">
            <img src="/image/kantan-navi-948-120.png" width="100%" />
          </a>
        </Row>
          <Col className="content-products-list" md={12} sm={12} sx={6}>
            {categories &&
              categories.map(category => (
                <Category
                  category={category}
                  handleProductSelect={handleProductSelect}
                  key={category.id}
                />
              ))}
          </Col>
        </Row>
        <Row>
          <a href="//www.lixil.co.jp/reform/web-reformconcierge/?banner_type=concierge_from_showroom">
            <img src="//www.lixil.co.jp/showroom/pic/bnr_web_concierge.png" width="100%" />
          </a>
        </Row>
        <Row>
          <p name="returnshowroom" id="returnshowroom" className="btn-back">
            <a href={"http://www.lixil.co.jp/showroom/" + showroom.Area.directory + "/" + showroom.directory} style={{ width: 200 }}>ショールーム詳細ページに戻る</a>
          </p>
        </Row>
      </div>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Showroom/Showroom.js